import React from 'react'
import { ListItemText } from '@mui/material'
import { BotaoItem, IconeItem } from './ItemMenu.styles'
import { useMenuLateral } from '../context/MenuLateralProvider/MenuLateralProvider'
import { useRedirectPlatform } from 'hooks/useRedirectPlatform'

export type ItemMenuProps = {
  nome: string
  rota: string
  icone?: string
  paddingleft?: number
  isPlatform?: boolean
  isPersonalizado?: boolean
}

export function ItemMenu({
  nome,
  rota,
  icone,
  paddingleft,
  isPlatform,
  isPersonalizado
}: ItemMenuProps) {
  const { itemSelecionado } = useMenuLateral()
  const { redirecionarPlataforma } = useRedirectPlatform()

  const handleClick = async (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    rotaItem: string
  ) => {
    redirecionarPlataforma(rotaItem, isPlatform, isPersonalizado)
  }

  return (
    <BotaoItem
      sx={{ pl: paddingleft }}
      selected={itemSelecionado.startsWith(rota)}
      onClick={event => handleClick(event, rota)}
    >
      {icone ? (
        <IconeItem>
          <img src={icone} height={20} alt="icone de plataforma" />
        </IconeItem>
      ) : (
        <></>
      )}
      <ListItemText primary={nome} />
    </BotaoItem>
  )
}
